<div class="migration-banner" *ngIf="visible">
  <button
    type="button"
    mat-icon-button
    class="migration-banner__close"
    [attr.aria-label]="'migrationBanner.close' | translate"
    (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </button>

  <div class="migration-banner__icon">
    <mat-icon>campaign</mat-icon>
  </div>

  <div class="migration-banner__body">
    <div class="migration-banner__heading">
      <span class="migration-banner__title">{{ 'migrationBanner.title' | translate }}</span>
      <span class="migration-banner__badge">{{ 'migrationBanner.badge' | translate }}</span>
    </div>

    <p class="migration-banner__message" [innerHTML]="message1Html"></p>
    <p class="migration-banner__message">{{ 'migrationBanner.message2' | translate }}</p>

    <button
      type="button"
      class="migration-banner__merits-toggle"
      [attr.aria-expanded]="meritsExpanded"
      (click)="toggleMerits()">
      <span>{{ 'migrationBanner.meritsToggle' | translate }}</span>
      <mat-icon>{{ meritsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
    </button>

    <div class="migration-banner__merits" *ngIf="meritsExpanded">
      <ul>
        <li *ngFor="let key of meritKeys">{{ key | translate }}</li>
      </ul>
      <p class="migration-banner__closing">{{ 'migrationBanner.closing' | translate }}</p>
    </div>
  </div>

  <div class="migration-banner__action">
    <button
      mat-flat-button
      color="primary"
      type="button"
      class="migration-banner__open-button"
      (click)="openNewManagementConsole()">
      <mat-icon>open_in_new</mat-icon>
      {{ 'migrationBanner.openButton' | translate }}
    </button>
  </div>
</div>
